import currency from 'currency.js';
import _ from 'lodash';

export const createButtonFilterItems = (
  field: any,
  data: any,
  fieldToSearch?: string,
) => {
  const ret: any[] = [];
  data?.forEach((d: any) => {
    // TODO: determine why this unused definition of val is here, or delete it.
    // const val = typeof d === 'string' ? d : d[fieldToSearch ?? field];

    if (!_.some(ret, (x) => x.value === d[field])) {
      const val =
        typeof d === 'object' && d.constructor === Object
          ? d[fieldToSearch ?? field]
          : d;
      ret.push({
        field: field,
        value: val,
        originalValue: val,
      });
    }
  });
  return ret;
};

export const applyMark = (val: any, replacement: string) => {
  return val
    ? val
        .toString()
        .replace(
          new RegExp(`(${_.escapeRegExp(replacement)})`, 'gi'),
          (match: string) => '<mark>' + match + '</mark>',
        )
    : '';
};

export const formatDate = (val: string) => {
  const date = new Date(val);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Months are zero-based, so add 1
  const day = date.getDate();
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;
  return `${formattedMonth}/${formattedDay}/${year}`;
};

export const formatDateForSubmission = (val: string) => {
  if (!val || val === 'undefined') {
    return undefined;
  }

  const date = new Date(val);
  const formattedDate = date.toISOString().split('T')[0];
  return formattedDate;
};

/**
 * Formats an ISO-8601 date (e.g. "2026-06-09") as "Jun 9, 2026". Date-only
 * strings are parsed as local dates to avoid a timezone off-by-one. Returns an
 * em dash for missing/invalid input.
 */
export const formatShortDate = (value?: string): string => {
  if (!value) return '—';

  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = dateOnly ? new Date(`${value}T00:00:00`) : new Date(value);

  if (Number.isNaN(date.getTime())) return '—';

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatMoney = (amount: any) => {
  if (isNaN(amount) || amount == null || amount == 0) {
    return '—';
  }
  const formattedMoney = currency(amount, {
    symbol: '$',
    precision: 2,
  }).format();

  return formattedMoney;
};


